import Script from "next/script";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { initializeConsentController } from "./controller";
import { installConsentInteractions } from "./interactions";
import { USConsentNotice } from "./us-notice";
export { useIubendaPreferences } from "./hooks";
export { resolveIubendaPreferences, type IubendaPreferenceState } from "./model";
const IUBENDA_SITE_ID = process.env.NEXT_PUBLIC_IUBENDA_SITE_ID;
const BANNER_CONTENT_OPT_IN = "We use strictly necessary and additional cookies to provide you with the best online experience. " + "Read our %{cookie_policy_link}.";
export function IubendaScript() {
  const [initialized, setInitialized] = useState(false);
  const router = useRouter();
  useEffect(() => {
    if (!IUBENDA_SITE_ID) return;
    initializeConsentController();
    setInitialized(true);
    return installConsentInteractions(router.events);
  }, [router.events]);
  if (!IUBENDA_SITE_ID || !initialized) return null;
  return <>
      <Script src="https://cdn.iubenda.com/cs/gpp/stub.js" strategy="afterInteractive" />
      <Script id="iubenda" strategy="afterInteractive" dangerouslySetInnerHTML={{
      __html: `
        var _iub = _iub || [];
        _iub.csConfiguration = {
          "applyGdprForCH": true,
          "askConsentAtCookiePolicyUpdate": true,
          "countryDetection": true,
          "enableFadp": true,
          "enableLgpd": true,
          "enableTcf": false,
          "enableUspr": true,
          "showBannerForUS": false,
          "privacyPolicyNoticeAtCollectionUrl": "https://ouster.com/privacy-policy/",
          "floatingPreferencesButtonDisplay": "bottom-right",
          // The application is the sole writer, including the US interaction hold.
          "googleConsentMode": false,
          "gdprAppliesGlobally": false,
          "lang": "en",
          "lgpdAppliesGlobally": false,
          "perPurposeConsent": true,
          "siteId": ${IUBENDA_SITE_ID},
          "storage": { "useSiteId": true },
          "whitelabel": false,
          "cookiePolicyId": 48799615,
          "banner": {
            "applyStyles": false,
            "acceptButtonDisplay": true,
            "acceptButtonCaption": "Accept All",
            "closeButtonDisplay": false,
            "content": ${JSON.stringify(BANNER_CONTENT_OPT_IN)},
            "cookiePolicyLinkCaption": "Cookie Policy",
            "customizeButtonDisplay": true,
            "customizeButtonCaption": "Go to my cookie choices",
            "explicitWithdrawal": false,
            "listPurposes": false,
            "ownerName": "ouster.com",
            "privacyPolicyUrl": "https://ouster.com/privacy-policy/",
            "position": "float-bottom-center",
            "rejectButtonDisplay": true,
            "rejectButtonCaption": "Reject All",
            "showPurposesToggles": false,
            "showTotalNumberOfProviders": false
          },
          "callback": {
            onReady: function() { window.ousterConsentCallback("ready"); },
            onPreferenceNotNeeded: function() { window.ousterConsentCallback("notNeeded"); },
            onPreferenceExpressed: function() { window.ousterConsentCallback("restored"); },
            onPreferenceFirstExpressed: function() { window.ousterConsentCallback("saved"); },
            on2ndLayerShown: function() { window.ousterConsentCallback("shown"); },
            on2ndLayerClosed: function() { window.ousterConsentCallback("closed"); }
          }
        };
        // Keep configuration and loader ordered in one script.
        var iubendaLoader = document.createElement("script");
        iubendaLoader.src = "https://cdn.iubenda.com/cs/iubenda_cs.js";
        iubendaLoader.charset = "UTF-8";
        document.head.appendChild(iubendaLoader);
      `
    }} />
      <USConsentNotice />
    </>;
}